import React from 'react';
import { Box, Typography } from '@mui/material';

const EnergyLabel = ({
  icon,
  title,
  subText,
  mainText,
}) => {
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 0.5,
      minWidth: 96,
    }}>
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& svg": { maxWidth: 48, maxHeight: 48 },
        // The icons are drawn in navy with white details; map both to theme colours so they work in dark mode
        "& svg [fill='#142784']": { fill: "var(--c-brand)" },
        "& svg [stroke='#142784']": { stroke: "var(--c-brand)" },
        "& svg [fill='white']": { fill: "var(--c-surface)" },
      }}>
        {icon}
      </Box>

      <Typography sx={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "var(--c-text-muted)",
        lineHeight: 1,
      }}>
        {title}
      </Typography>

      <Typography sx={{
        fontSize: 22,
        fontWeight: 700,
        color: mainText ? "var(--c-brand)" : "var(--c-border-strong)",
        lineHeight: 1.1,
        fontVariantNumeric: "tabular-nums",
      }}>
        {mainText || "–"}
      </Typography>

      {subText && (
        <Typography sx={{
          fontSize: 12,
          fontWeight: 500,
          color: "var(--c-text-3)",
          backgroundColor: "var(--c-muted)",
          borderRadius: "999px",
          px: 1,
          py: 0.25,
          lineHeight: 1.4,
        }}>
          {subText}
        </Typography>
      )}
    </Box>
  );
}

export default EnergyLabel
